export default __webpack_public_path__ + "ajax.1b212b85.png";